import Pusher from "pusher-js";

import { pushChatMessage, pushNewMessage, store } from '../store'

let authorizer = (channel: any, options: any) => {
  const token = localStorage.getItem("token");
  return {
    authorize: (socketId: any, callback: any) => {
      fetch("https://api.atlaskit.app/api/auth", {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          authorization: token ? `Bearer ${token}` : "",
        }),
        body: JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name,
        }),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(
              `Received ${res} from ${"https://api.atlaskit.app/api/auth"}`
            );
          }
          return res.json();
        })
        .then((data) => {
          callback(null, data);
        })
        .catch((err) => {
          callback(new Error(`Error calling auth endpoint: ${err}`), {
            auth: "",
          });
        });
    },
  };
};

class PusherClient {
  pusherBus: any;
  channel: any;

  constructor() {
    this.pusherBus = null;
    this.channel = null;
    if(this.pusherBus != null) return
    this.startPusherSocket();
  }

  private async startPusherSocket() {
    this.pusherBus = await new Pusher("9c686de50d8c8bedbe54", {
      cluster: "eu",
      httpHost: "api.atlaskit.app",
      wsHost: "api.atlaskit.app",
      // httpPath:"http://178.79.176.22:80",forceTLS:false,wsPath:"ws://178.79.176.22:6001",
      // httpPort: 80,
      wsPort: 6001,
      wssPort: 6001,
      authorizer,
      enabledTransports: ['ws', 'wss']
    });
    console.log(store?.getState()?.userInfoReducer?.content,"my id from pusher")
    // this.channel = await this.pusherBus.subscribe(`private-GeneralMessage.${store?.getState()?.userInfoReducer?.content?.id}`);
    this.channel = await this.pusherBus.subscribe(`private-GeneralMessage.2`);
    
    // setInterval(() => {
    //   this.channel.trigger('client-IsTyping',{  })   
    // }, 3000);
    
    this.channel.bind("GeneralMessage", (cb: any) => {
      console.log(cb);
      store.dispatch(pushChatMessage(cb))
    });
    this.channel.bind("client-IsTyping", (cb: any) => {
      console.log("isTyping")
      console.log(cb);
      store.dispatch(pushChatMessage(cb))
    });
  }

  public async subscribeToAllChatRooms(myChats: any) {
    this.pusherBus = await new Pusher("9c686de50d8c8bedbe54", {
      cluster: "eu",
      httpHost: "api.atlaskit.app",
      wsHost: "api.atlaskit.app",
      // httpPath:"http://178.79.176.22:80",forceTLS:false,wsPath:"ws://178.79.176.22:6001",
      // httpPort: 80,
      wsPort: 6001,
      wssPort: 6001,
      authorizer,
      enabledTransports: ['ws', 'wss']
    });
    for (let i = 0; i < myChats.length; i++) {
      // const element = array[i];
      let chatChannel = this.pusherBus.subscribe(`private-ChatRoom.${myChats[i].id}`);
      chatChannel.bind("IsTyping",  (UserThatIsTyping:any) => {
        setTimeout(() => {
          
        }, 3000);
      });
      
      chatChannel.bind("GeneralMessage", (e:any) => {
        console.log("event", e)
      });
    }
  }

  isTyping({userId}:{userId:string,}){
    this.channel.trigger('IsTyping',{  })
  }

  sendChatMessage(message: string) {
    this.channel.trigger("client-GeneralMessage", { message });
  }

}

// PUSHER_APP_ID=865651
// PUSHER_APP_KEY=9c686de50d8c8bedbe54
// PUSHER_APP_SECRET=71c2ee29a122cfa41259
// PUSHER_APP_CLUSTER=eu

const pusherMessageClient = () => new PusherClient();
export default pusherMessageClient
